(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-events"] && !Shopify.designMode) return;
  try {
    function publishSquishyEvent(name, payload = {}) {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return false;

    window.Shopify.analytics.publish(name, payload);
    return true;
  }

  function initializeSquishyEvents() {
    document.querySelectorAll('[data-squishy-success-event]').forEach((marker) => {
      publishSquishyEvent(marker.dataset.squishySuccessEvent, {
        form_version: marker.dataset.formVersion || 'theme-contact-v1',
      });
    });

    document.querySelectorAll('[data-filter-form]').forEach((form) => {
      form.addEventListener('submit', () => {
        publishSquishyEvent('squishy:filter_used', {
          surface: form.dataset.filterSurface || 'storefront',
        });
      });
    });
  }

  window.publishSquishyEvent = publishSquishyEvent;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSquishyEvents, { once: true });
  } else {
    initializeSquishyEvents();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tsf-shipping-progress')) {
    customElements.define('tsf-shipping-progress', class extends HTMLElement {
      static get observedAttributes() { return ['data-subtotal', 'data-currency', 'data-country']; }
      connectedCallback() { this.render(); }
      attributeChangedCallback() { if (this.isConnected) this.render(); }
      render() {
        const message = this.querySelector('[data-shipping-message]');
        const progress = this.querySelector('progress');
        if (!message || !progress) return;
        const subtotal = Number(this.dataset.subtotal);
        const eligible = this.dataset.currency === 'USD' && this.dataset.country === 'US' && Number.isFinite(subtotal) && subtotal >= 0;
        progress.hidden = !eligible;
        if (!eligible) { message.textContent = this.dataset.policy; return; }
        const remaining = Math.max(0, 4000 - subtotal);
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(remaining / 100);
        message.textContent = remaining > 0 ? this.dataset.remaining.replace('__amount__', amount) : this.dataset.unlocked;
        progress.value = Math.min(4000, subtotal);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
